<template>
    <!-- 홈 통계 카드: 제목 + 합계, 항목별 가로 막대 (막대 길이 = 가장 많은 항목 기준, 오른쪽 = 수 · 비율) -->
    <div class="hb-card">
        <div class="hb-head">
            <h4 class="hb-title">{{ title }}</h4>
            <p class="hb-total"><span>{{ totalLabel }}</span> <b>{{ fmt(sum) }}</b>{{ unit }}</p>
        </div>
        <ul class="hb-list">
            <li v-for="it in rows" :key="it.label" class="hb-row" :class="{ zero: !it.value }" :title="it.label + ' ' + fmt(it.value) + unit + ' (' + it.pct + '%)'">
                <span class="hb-label"><i :style="{ background: it.color }"></i>{{ it.label }}</span>
                <span class="hb-track"><span class="hb-bar" :style="{ width: it.width + '%', background: it.color }"></span></span>
                <span class="hb-val"><b>{{ fmt(it.value) }}</b><small>{{ unit }}</small><em>{{ it.pct }}%</em></span>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'HomeBars',
    props: {
        title: String,
        totalLabel: { type: String, default: '전체' },
        total: { type: Number, default: null },   //없으면 항목 합
        unit: { type: String, default: '마리' },
        items: { type: Array, default: () => [] },   //[{ label, value, color }]
    },
    computed: {
        sum() {
            if (this.total != null && !isNaN(this.total)) return Number(this.total);
            return this.items.reduce((t, i) => t + (Number(i.value) || 0), 0);
        },
        rows() {
            const vals = this.items.map(i => Number(i.value) || 0);
            const max = Math.max(1, ...vals);
            const base = vals.reduce((t, v) => t + v, 0);
            return this.items.map((i, k) => ({
                ...i, value: vals[k],
                width: vals[k] ? Math.max(1.5, vals[k] / max * 100) : 0,
                pct: base ? (Math.round(vals[k] / base * 1000) / 10).toFixed(1) : '0.0',
            }));
        },
    },
    methods: {
        fmt(v) { return (Number(v) || 0).toLocaleString(); },
    },
};
</script>

<style scoped>
    .hb-card { background: #fff; border: 1px solid #ededed; border-radius: 12px; padding: 18px 20px 14px; text-align: left; height: 100%; }
    .hb-head { display: flex; align-items: baseline; justify-content: space-between; gap: 8px; margin-bottom: 14px; }
    .hb-title { font-size: 17px !important; font-weight: 700; color: #222; margin: 0 !important; }
    .hb-total { margin: 0 !important; font-size: 13px !important; color: #888; white-space: nowrap; }
    .hb-total b { font-size: 20px; color: #222; font-weight: 800; font-variant-numeric: tabular-nums; }
    .hb-list { list-style: none; padding: 0; margin: 0; }
    .hb-row { display: grid; grid-template-columns: 76px 1fr auto; align-items: center; gap: 10px; padding: 6px 0; }
    .hb-row + .hb-row { border-top: 1px dashed #f0f0f0; }
    .hb-label { font-size: 13.5px; color: #444; font-weight: 600; display: flex; align-items: center; gap: 6px; white-space: nowrap; }
    .hb-label i { width: 8px; height: 8px; border-radius: 2px; flex: none; }
    .hb-track { height: 12px; background: #F5F5F6; border-radius: 6px; overflow: hidden; }
    .hb-bar { display: block; height: 100%; border-radius: 6px; transition: width .4s ease; }
    .hb-val { min-width: 104px; text-align: right; font-variant-numeric: tabular-nums; white-space: nowrap; }
    .hb-val b { font-size: 14.5px; color: #222; font-weight: 700; }
    .hb-val small { font-size: 11.5px; color: #888; margin-left: 1px; }
    .hb-val em { font-style: normal; display: inline-block; min-width: 46px; font-size: 12.5px; color: #999; margin-left: 6px; }
    .hb-row.zero .hb-label, .hb-row.zero .hb-val b { color: #bbb; }
    @media (max-width: 768px) {
        .hb-card { padding: 14px 14px 10px; }
        .hb-row { grid-template-columns: 64px 1fr auto; gap: 8px; }
        .hb-val { min-width: 92px; }
    }
</style>
